import React from 'react';

import { createDashboardPageClassName } from './dashboardPageStyles';

type TProps = {
  text: string;
};

export const DashboardPageSubtitle: React.FC<TProps> = ({ text }) => (
  <div className={createDashboardPageClassName('subtitle')}>{text}</div>
);
